// Copyright (c) 2026, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { AuthReactConfig } from "@asgardeo/auth-react";

export const AsgardeoConfig: AuthReactConfig = {
  clientID: window.config.ASGARDEO_CLIENT_ID,
  baseUrl: window.config.ASGARDEO_BASE_URL,
  signInRedirectURL: window.config.AUTH_SIGN_IN_REDIRECT_URL,
  signOutRedirectURL: window.config.AUTH_SIGN_OUT_REDIRECT_URL,
  scope: ["openid", "email", "groups", "profile"],
};

export const AppConfig = {
  BACKEND_URL: window.config.BACKEND_URL,
};

export const APP_NAME = "Asset App";
